<template>
  <el-container>
    <el-aside width="200px">
      <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
      >
        <el-menu-item index="1">
          <router-link :to="{name: 'ScenicSpots'}">
            <span>景区管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="{name: 'Hotels'}">
            <span>酒店管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="{name: 'Cards'}">
            <span>卡片管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link :to="{name: 'Operators'}">
            <span>操作员申请</span>
          </router-link>
        </el-menu-item>
        <el-menu-item @click="logout">
          退出登录
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
import Cookies from 'js-cookie'
import {useRouter} from 'vue-router'

export default {
  setup(){
    const router = useRouter()

    const logout = () => {
      Cookies.remove('token')
      Cookies.remove('user')
      router.replace({name: 'Login'})
    }

    return {logout}
  }
}
</script>
